import React from "react";

const ProjeKartLoader = () => {
  return (
    <div className="flex flex-col gap-4">
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            className="p-3 px-8 bg-gray-100 rounded-2xl shadow-cardShadow animate-pulse"
          >
            <div className="w-full h-32 bg-gray-100 rounded-2xl mb-2" />
          </div>
        ))}
    </div>
  );
};

export default ProjeKartLoader;
